'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var reactToastify = require('react-toastify');
require('react-toastify/dist/ReactToastify.css');
var Toast_module = require('../Toast/Toast.module.scss.js');

var LimbicContext = React.createContext(null);
var LimbicProvider = function (_a) {
    var children = _a.children;
    return (jsxRuntime.jsxs(LimbicContext.Provider, _tslib.__assign({ value: null }, { children: [jsxRuntime.jsx(reactToastify.ToastContainer, { className: Toast_module["default"].toastContainer }), children] })));
};

exports["default"] = LimbicProvider;
//# sourceMappingURL=LimbicContext.js.map
